import { Stack } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { IconPlus } from "@tabler/icons-react"
import { Button } from "@tfg/ui"

import { CreateOrUpdateDisplaySettingsModal } from "~/pages/Brand/OrganizationSettings/ProductPages/DisplaySettingsCrud/CreateOrUpdateDisplaySettingsModal.tsx"

interface Props {
  organizationSettingsId: number
  organizationId: number
}

export const CreateDisplaySetting = ({
  organizationSettingsId,
  organizationId,
}: Props) => {
  const [opened, { open, close }] = useDisclosure()

  return (
    <Stack>
      <Button
        icon={<IconPlus />}
        onClick={() => open()}
        w="fit-content"
        variant="admin"
      >
        Create Display Setting
      </Button>
      <CreateOrUpdateDisplaySettingsModal
        opened={opened}
        close={close}
        organizationSettingsId={organizationSettingsId}
        organizationId={organizationId}
      />
    </Stack>
  )
}
